'use client';

import React from 'react';
import { Icon } from './Icon';
import { themeColors } from '../theme/theme';

/**
 * TextFilter - Reusable search/filter input component
 * @param {Object} props
 * @param {string} props.value - Current filter value
 * @param {function} props.onChange - Callback when filter changes
 * @param {string} [props.placeholder] - Placeholder text
 * @param {object} [props.style] - Optional style override
 */
export function TextFilter({ value, onChange, placeholder = 'Filter by ID, text...', style }) {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        background: '#f8f9fa',
        borderRadius: 20,
        border: '1px solid #e0e0e0',
        padding: '6px 14px',
        width: '100%',
        maxWidth: 320,
        ...style,
      }}
    >
      <Icon name="search" size="small" style={{ marginRight: 8, color: '#888', fontSize: 18 }} />
      <input
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        style={{
          border: 'none',
          outline: 'none',
          fontSize: '14px',
          flex: 1,
          background: 'transparent',
          color: themeColors.textColor,
          fontFamily: themeColors.fontFamily,
        }}
      />
      {value && (
        <button
          onClick={() => onChange('')}
          style={{
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            padding: 0,
            display: 'flex',
            alignItems: 'center',
            marginLeft: 4,
          }}
          aria-label="Clear filter"
        >
          <Icon name="close" size="small" style={{ color: '#888', fontSize: 16 }} />
        </button>
      )}
    </div>
  );
}
